"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var encUtils = tslib_1.__importStar(require("enc-utils"));

function convertArrayBufferToBuffer(arrBuf) {
  return encUtils.arrayToBuffer(new Uint8Array(arrBuf));
}

exports.convertArrayBufferToBuffer = convertArrayBufferToBuffer;

function convertArrayBufferToUtf8(arrBuf) {
  return encUtils.arrayToUtf8(new Uint8Array(arrBuf));
}

exports.convertArrayBufferToUtf8 = convertArrayBufferToUtf8;

function convertArrayBufferToHex(arrBuf, noPrefix) {
  return encUtils.arrayToHex(new Uint8Array(arrBuf), !noPrefix);
}

exports.convertArrayBufferToHex = convertArrayBufferToHex;

function convertArrayBufferToNumber(arrBuf) {
  return encUtils.arrayToNumber(new Uint8Array(arrBuf));
}

exports.convertArrayBufferToNumber = convertArrayBufferToNumber;

function concatArrayBuffers() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return encUtils.hexToArray(args.map(function (b) {
    return encUtils.arrayToHex(new Uint8Array(b));
  }).join("")).buffer;
}

exports.concatArrayBuffers = concatArrayBuffers;

function convertBufferToArrayBuffer(buf) {
  return encUtils.bufferToArray(buf).buffer;
}

exports.convertBufferToArrayBuffer = convertBufferToArrayBuffer;

function convertBufferToUtf8(buf) {
  return encUtils.bufferToUtf8(buf);
}

exports.convertBufferToUtf8 = convertBufferToUtf8;

function convertBufferToHex(buf, noPrefix) {
  return encUtils.bufferToHex(buf, !noPrefix);
}

exports.convertBufferToHex = convertBufferToHex;

function convertBufferToNumber(buf) {
  return encUtils.bufferToNumber(buf);
}

exports.convertBufferToNumber = convertBufferToNumber;

function concatBuffers() {
  return encUtils.concatBuffers.apply(encUtils, arguments);
}

exports.concatBuffers = concatBuffers;

function convertUtf8ToArrayBuffer(utf8) {
  return encUtils.utf8ToArray(utf8).buffer;
}

exports.convertUtf8ToArrayBuffer = convertUtf8ToArrayBuffer;

function convertUtf8ToBuffer(utf8) {
  return encUtils.utf8ToBuffer(utf8);
}

exports.convertUtf8ToBuffer = convertUtf8ToBuffer;

function convertUtf8ToHex(utf8, noPrefix) {
  return encUtils.utf8ToHex(utf8, !noPrefix);
}

exports.convertUtf8ToHex = convertUtf8ToHex;

function convertUtf8ToNumber(utf8) {
  return encUtils.utf8ToNumber(utf8);
}

exports.convertUtf8ToNumber = convertUtf8ToNumber;

function convertHexToBuffer(hex) {
  return encUtils.hexToBuffer(hex);
}

exports.convertHexToBuffer = convertHexToBuffer;

function convertHexToArrayBuffer(hex) {
  return encUtils.hexToArray(hex).buffer;
}

exports.convertHexToArrayBuffer = convertHexToArrayBuffer;

function convertHexToUtf8(hex) {
  return encUtils.hexToUtf8(hex);
}

exports.convertHexToUtf8 = convertHexToUtf8;

function convertHexToNumber(hex) {
  return encUtils.hexToNumber(hex);
}

exports.convertHexToNumber = convertHexToNumber;

function convertNumberToBuffer(num) {
  return encUtils.numberToBuffer(num);
}

exports.convertNumberToBuffer = convertNumberToBuffer;

function convertNumberToArrayBuffer(num) {
  return encUtils.numberToArray(num).buffer;
}

exports.convertNumberToArrayBuffer = convertNumberToArrayBuffer;

function convertNumberToUtf8(num) {
  return encUtils.numberToUtf8(num);
}

exports.convertNumberToUtf8 = convertNumberToUtf8;

function convertNumberToHex(num, noPrefix) {
  return encUtils.numberToHex(num, !noPrefix);
}

exports.convertNumberToHex = convertNumberToHex;